export default "__VITE_ASSET__BEGdCGyB__"